export class TransportInvoiceModel {
  transportInvoiceId: number = 0;
  companyId: number = 0;
  providerId: number = 0;
  documentNumber: string = '';
  dateTransportInvoice: Date = new Date();
  otherValues: number = 0;
  active: boolean = true;
  observation: string | null = null;
  createDate: string = '';
  userNameCreate: string = '';
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
